import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login-user",
  "use": "icon-login-user-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"icon-login-user\"><g stroke=\"currentColor\"><circle fill=\"transparent\" cx=\"7\" cy=\"4\" r=\"2.5\" /><path fill=\"transparent\" d=\"M1.814 13.5h10.372c.207-.477.314-.982.314-1.5 0-2.463-2.444-4.5-5.5-4.5S1.5 9.537 1.5 12c0 .518.107 1.023.314 1.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol